module.exports = __webpack_public_path__ + "static/media/15UN-Habitat12.cecd3793.jpg";